var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"works-filter__tags",staticStyle:{"max-width":"100%","flex":"auto"}},_vm._l((_vm.tags),function(tag){return _c('tag-item-sub',{attrs:{"tag":tag}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed3e69aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sub/flat_light/components/list/WorksTagsSub.vue
// module id = null
// module chunks = 